import React from 'react';
import { Container, Bar, Label } from './ProgressBar.styled';
import { ProgressBarDefaultProps, ProgressBarPropTypes } from './ProgressBar.prop-types';
export const ProgressBar = (props) => {
    const { progress = 0, width, disabled } = props;
    return (React.createElement(Container, { width: width },
        React.createElement(Bar, { progress: progress, disabled: disabled }, props.showPercentage &&
            React.createElement(Label, null, `${progress}% completo`))));
};
ProgressBar.propTypes = ProgressBarPropTypes;
ProgressBar.defaultProps = ProgressBarDefaultProps;
//# sourceMappingURL=ProgressBar.js.map